import { LocalStrorageService } from './../../services/local-strorage.service';
import { StudentService } from './../../services/student.service';
import { WindowService } from './../../services/window.service';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { ActivatedRoute, Router } from '@angular/router';
import * as firebase from 'firebase';
import { Student } from 'src/app/models/student';

export class PhoneNumber {
  country: string;
  phone: string;

  get e164(): string {
    const num = '996' + this.phone;
    return `+${num}`;
  }
}

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {
  incorrectCode = false;
  windowRef: any;
  phoneNumber = new PhoneNumber();
  verificationCode: string;
  user: any;
  checkIsUserRegistered = false;
  isUserRegisteredModal = false;
  userIsRegisteredModal = false;
  currentUser: Student = new Student();

  sendingVerificationCode = false;
  codeSent = false;
  codeVerifying = false;
  creatingAccount = false;
  accountCreated = false;
  accountAlreadyExists = false;
  public phone = '';
  authType = '';

  constructor(private db: AngularFirestore,
              private router: Router,
              private route: ActivatedRoute,
              private win: WindowService,
              private studentService: StudentService,
              private localStorageService: LocalStrorageService) {
    this.route.paramMap.subscribe(params => {
      this.authType = params.get('auth');
    });
  }

  ngOnInit(): void {
    this.windowRef = this.win.windowRef;
    this.windowRef.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
    this.windowRef.recaptchaVerifier.render();
  }

  login(): any {
    this.checkIsUserRegistered = true;
    this.studentService.getStudent(this.phoneNumber.e164).then(res => {
      if (!res) {
        this.checkIsUserRegistered = false;
        this.accountAlreadyExists = true;
      } else {
        this.checkIsUserRegistered = false;
        this.sendingVerificationCode = true;
        this.sendLoginCode();
      }
    });
  }

  register(): any {
    this.currentUser.phone = this.phoneNumber.e164;
    this.checkIsUserRegistered = true;
    this.studentService.getStudent(this.currentUser.phone).then(res => {
      if (!res) {
        this.checkIsUserRegistered = false;
        this.sendingVerificationCode = true;
        this.sendLoginCode();
      } else {
        this.checkIsUserRegistered = false;
        this.userIsRegisteredModal = true;
      }
    });
    console.log(this.currentUser);
  }

  sendLoginCode(): any {
    const appVerifier = this.windowRef.recaptchaVerifier;
    const num = this.phoneNumber.e164;
    firebase.auth().signInWithPhoneNumber(num, appVerifier)
      .then(result => {
        this.codeSent = true;
        this.windowRef.confirmationResult = result;
      })
      .catch(error => console.log(error));
  }

  verifyLoginCode(): any {
    this.codeVerifying = true;
    this.windowRef.confirmationResult
      .confirm(this.verificationCode)
      .then(result => {
        console.log(result.user.uid);
        this.studentService.getStudent(this.phoneNumber.e164).then((res) => {
          this.accountCreated = true;
          this.localStorageService.saveStudent(res);
          setTimeout(() => {
            this.router.navigateByUrl('/');
          }, 1000);
        });
      })
      .catch(error => {
        console.log(error, 'Incorrect code entered?');
        this.incorrectCode = true;
      });
  }

  verifyRegisterCode(): any {
    this.codeVerifying = true;
    this.windowRef.confirmationResult
      .confirm(this.verificationCode)
      .then(result => {
        this.codeVerifying = false;
        this.creatingAccount = true;
        // this.currentUser._id = result.user.uid;
        this.studentService.create(this.currentUser).then((res) => {
          this.accountCreated = true;
          this.creatingAccount = false;
          this.localStorageService.saveStudent(res);
          setTimeout(() => {
            this.router.navigateByUrl('/');
          }, 1000);
        });
      })
      .catch(error => {
        this.incorrectCode = true;
      });

  }

  routeToRegister(): any {
    this.isUserRegisteredModal = false;
    this.router.navigateByUrl('/student/register');
  }

  routeToLogin() {
    this.userIsRegisteredModal = false;
    this.router.navigateByUrl('/student/login');
  }

}
